import styled from "styled-components";

export const MainLayout = styled.div`
    padding: 5rem;
@media only screen and (max-width: 1000px){
    /* padding: 2rem; */
}
@media only screen and (max-width: 642px){
    padding: 4rem;
}
@media only screen and (max-width: 510px){
    padding: 3rem;
}

`;


export const InnerLayout = styled.div`
padding: 5rem 0;

`;